export const PREFERRED_VIDEO_TYPES = ['video/mp4;codecs=avc1,mp4a', 'video/webm;codecs=vp8,opus', 'video/webm'] as const

export function selectRecordingType(supported: (type: string) => boolean): string {
  const selected = PREFERRED_VIDEO_TYPES.find(supported)
  if (!selected) throw new Error('Video recording is not supported on this device')
  return selected
}

export function cleanMediaBlob(blob: Blob, fallbackType: string): Blob {
  if (blob.size === 0) throw new Error('That recording came back empty — please try again')
  const baseType = (blob.type || fallbackType).split(';')[0]!.trim()
  return blob.type === baseType ? blob : new Blob([blob], { type: baseType })
}

export function canPlayHevc(video: Pick<HTMLVideoElement, 'canPlayType'>): boolean {
  return video.canPlayType('video/mp4; codecs="hvc1"') !== ''
}
